import { useParams } from "react-router-dom";
import { getPerformedResponsibilityFields, getNow } from "../utils";
import Form from "./Form";
import { useDataContext } from "../contexts";

export default function PerformedResponsibilityAdd({ callback, user }) {
  const { submissionId } = useParams();

  const { memberUsers, responsibilities } = useDataContext();

  const performedResponsibilityFields = getPerformedResponsibilityFields(
    user,
    memberUsers,
    responsibilities
  );

  return (
    <Form
      path="performed-responsibilities"
      fields={performedResponsibilityFields}
      submitCallback={callback}
      initialValues={{
        user: user.id,
        datePerformed: getNow(),
        submission: submissionId,
      }}
    />
  );
}
